import constants from '../Utils/constants';
const initialState = {
  isCreateLinkedAccountLoading: false,
  isCreateStackholderAccountLoading: false,
  isCreateProductionConfigurationtLoading: false,
  isUpdateProductionConfigurationtLoading: false,
  isGetLinkedAccountLoading: false,
  isGetStackHolderAccountLoading: false,
  isGetProductConfigurationLoading: false,
  isAddExistingLinkedAccountIdLoading: false,
  allProductConfigurationData: [],
  allLinkedAccountData: [],
  allStackHolderData: [],
};

export const razorpaySplittingReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.GET_LINKED_ACCOUNT_REQUEST:
      return {
        ...state,
        isGetLinkedAccountLoading: true,
      };
    case constants.GET_LINKED_ACCOUNT_SUCCESS:
      return {
        ...state,
        isGetLinkedAccountLoading: false,
        allLinkedAccountData: action.payload,
      };
    case constants.GET_LINKED_ACCOUNT_FAILURE:
      return {
        ...state,
        isGetLinkedAccountLoading: false,
      };
    case constants.CREATE_LINKED_ACCOUNT_REQUEST:
      return {
        ...state,
        isCreateLinkedAccountLoading: true,
      };
    case constants.CREATE_LINKED_ACCOUNT_SUCCESS:
      return {
        ...state,
        isCreateLinkedAccountLoading: false,
      };
    case constants.CREATE_LINKED_ACCOUNT_FAILURE:
      return {
        ...state,
        isCreateLinkedAccountLoading: false,
      };
    case constants.ADD_EXISTING_LINKED_ACCOUNT_ID_REQUEST:
      return {
        ...state,
        isAddExistingLinkedAccountIdLoading: true,
      };
    case constants.ADD_EXISTING_LINKED_ACCOUNT_ID_SUCCESS:
      return {
        ...state,
        isAddExistingLinkedAccountIdLoading: false,
      };
    case constants.ADD_EXISTING_LINKED_ACCOUNT_ID_FAILURE:
      return {
        ...state,
        isAddExistingLinkedAccountIdLoading: false,
      };
    case constants.GET_STACKHOLDER_ACCOUNT_REQUEST:
      return {
        ...state,
        isGetStackHolderAccountLoading: true,
      };
    case constants.GET_STACKHOLDER_ACCOUNT_SUCCESS:
      return {
        ...state,
        isGetStackHolderAccountLoading: false,
        allStackHolderData: action.payload,
      };
    case constants.GET_STACKHOLDER_ACCOUNT_FAILURE:
      return {
        ...state,
        isGetStackHolderAccountLoading: false,
      };
    case constants.CREATE_STACKHOLDER_ACCOUNT_REQUEST:
      return {
        ...state,
        isCreateStackholderAccountLoading: true,
      };
    case constants.CREATE_STACKHOLDER_ACCOUNT_SUCCESS:
      return {
        ...state,
        isCreateStackholderAccountLoading: false,
      };
    case constants.CREATE_STACKHOLDER_ACCOUNT_FAILURE:
      return {
        ...state,
        isCreateStackholderAccountLoading: false,
      };
    case constants.GET_PRODUCT_CONFIGURATION_REQUEST:
      return {
        ...state,
        isGetProductConfigurationLoading: true,
      };
    case constants.GET_PRODUCT_CONFIGURATION_SUCCESS:
      return {
        ...state,
        isGetProductConfigurationLoading: false,
        allProductConfigurationData: action.payload,
      };
    case constants.GET_PRODUCT_CONFIGURATION_FAILURE:
      return {
        ...state,
        isGetProductConfigurationLoading: false,
      };
    case constants.CREATE_PRODUCT_CONFIGURATION_REQUEST:
      return {
        ...state,
        isCreateProductionConfigurationtLoading: true,
      };
    case constants.CREATE_PRODUCT_CONFIGURATION_SUCCESS:
      return {
        ...state,
        isCreateProductionConfigurationtLoading: false,
      };
    case constants.CREATE_PRODUCT_CONFIGURATION_FAILURE:
      return {
        ...state,
        isCreateProductionConfigurationtLoading: false,
      };
    case constants.UPDATE_PRODUCT_CONFIGURATION_REQUEST:
      return {
        ...state,
        isUpdateProductionConfigurationtLoading: true,
      };
    case constants.UPDATE_PRODUCT_CONFIGURATION_SUCCESS:
      return {
        ...state,
        isUpdateProductionConfigurationtLoading: false,
      };
    case constants.UPDATE_PRODUCT_CONFIGURATION_FAILURE:
      return {
        ...state,
        isUpdateProductionConfigurationtLoading: false,
      };
    default:
      return state;
  }
};
